import React from "react";
import { Link } from "react-router-dom";
import karigar from "../assets/karigar1.avif";
import "../styles/About.css";
function About() {
  return (
    <div className="about">
      <h1>About us</h1>
      <div
        className="aboutTop"
        style={{ backgroundImage: `url(${karigar})` }}
      ></div>
      <div className="aboutBottom">
        
        {/* About Us Section */}
        <div className="about-section">
          <h2>False Ceiling Services – GetKarigar</h2>
          <p>
            At GetKarigar, we are your one-stop solution for professional false ceiling services. Backed by our parent company Getcon Media Pvt. Ltd. (founded in 2019), our mission is to make home interiors and construction services simple, affordable, and reliable.
          </p>
          <p>
            We specialize in gypsum false ceilings, POP ceilings, PVC ceilings, wooden false ceilings, and modular designer ceilings for both residential and commercial projects. With a network of verified technicians, architects, and design experts, GetKarigar ensures that every ceiling installation is handled with precision, creativity, and quality workmanship.
          </p>
        </div>

        {/* Why Choose Us Section */}
        <div className="why-choose-section">
          <h2>Why Choose GetKarigar for False Ceiling Work?</h2>
          <div className="why-choose-list">
            <div className="why-choose-item">
              <span className="checkmark">✅</span>
              <strong>Expert False Ceiling Contractors</strong> – Skilled professionals trained in modern ceiling designs.
            </div>
            <div className="why-choose-item">
              <span className="checkmark">✅</span>
              <strong>Wide Range of Ceiling Designs</strong> – Gypsum ceilings, POP ceilings, PVC panels, wooden ceilings, 3D designer ceilings, and more.
            </div>
            <div className="why-choose-item">
              <span className="checkmark">✅</span>
              <strong>Affordable False Ceiling Installation</strong> – Premium quality at competitive prices.
            </div>
            <div className="why-choose-item">
              <span className="checkmark">✅</span>
              <strong>Durability & Finishing</strong> – Long-lasting materials with a professional touch.
            </div>
            <div className="why-choose-item">
              <span className="checkmark">✅</span>
              <strong>Convenience</strong> – Quick booking, transparent pricing, and doorstep service.
            </div>
          </div>
        </div>

        {/* Service Locations Section */}
        <div className="service-locations-section">
          <h2>Service Locations</h2>
          <p>
            We provide false ceiling installation services across Delhi NCR cities in India, including:
          </p>
          <p className="locations-list">
            Delhi, Ghaziabad, Noida, Gurugram etc.
          </p>
        </div>

        {/* Contact Section */}
        <div className="contact-section">
          <h2>Get in touch with us</h2>
          <Link to="/contact">
            <button className="contact-us-button">Contact Us</button>
          </Link>
        </div>      </div>
    </div>
  );
}

export default About;
